document.addEventListener('DOMContentLoaded', function() {
    const $scrollToTops = document.querySelectorAll('.scroll-to-top');
    const headerThreshold = 500;

    $scrollToTops.forEach($scrollToTop => {
        $scrollToTop.addEventListener('click', function(e) {
            e.preventDefault();

            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            });
        });
    });


    let updating = false,
        lastScrollOffset = 0,
        prevScrollOffset = 0
    ;
        

    function onScroll() {
        lastScrollOffset = window.scrollY;
        requestUpdate();
    }

    function requestUpdate() {
        if(!updating) {
            requestAnimationFrame(update);
            updating = true;
        }
    }

    function update() {
        if(lastScrollOffset > (headerThreshold / 2)) {
            $scrollToTops.forEach($scrollToTop => {
                $scrollToTop.classList.add('show');
            });
        }
        else {
            $scrollToTops.forEach($scrollToTop => {
                $scrollToTop.classList.remove('show');
            });
        }

        prevScrollOffset = lastScrollOffset;
        updating = false;
    }
 
    window.addEventListener('scroll', onScroll, false);
    window.addEventListener('resize', requestUpdate, false);

    onScroll();
});